/**
 * Category Grid Section - Interactive Tab Switching & Navigation
 */
(() => {
  const bindSection = (root) => {
    if (!root || root.dataset.cgBound === 'true') return;
    root.dataset.cgBound = 'true';

    const tabButtons = Array.from(root.querySelectorAll('[data-cg-tab]'));
    const views = Array.from(root.querySelectorAll('[data-cg-view]'));
    const heading = root.querySelector('[data-cg-heading]');

    // Get label settings from section
    const goalsLabel = root.dataset.goalsLabel || 'Goal';
    const categoriesLabel = root.dataset.categoriesLabel || 'Category';

    /**
     * Switch active tab view
     */
    const setActiveTab = (tab) => {
      // Update tab buttons
      tabButtons.forEach((btn) => {
        const isActive = btn.dataset.cgTab === tab;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Update views with animation
      views.forEach((view) => {
        const isActive = view.dataset.cgView === tab;
        view.classList.toggle('is-active', isActive);

        if (isActive) {
          // Trigger re-animation
          view.classList.remove('cg-animate');
          void view.offsetWidth; // Force reflow
          view.classList.add('cg-animate');
        }
      });

      // Update heading text
      if (heading) {
        heading.textContent = tab === 'goals' ? goalsLabel : categoriesLabel;
      }
    };

    // Tab click handlers
    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        setActiveTab(btn.dataset.cgTab);
      });
    });

    // Quick link click handlers (inside goal cards)
    root.querySelectorAll('[data-cg-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const url = link.dataset.cgUrl;
        if (url && url !== '#') {
          window.location.href = url;
        }
      });
    });
  };

  /**
   * Initialize all category grid sections
   */
  const init = () => {
    document.querySelectorAll('[data-category-grid]').forEach((root) => {
      bindSection(root);
    });
  };

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section) return;

    section.querySelectorAll('[data-category-grid]').forEach((root) => {
      root.dataset.cgBound = 'false'; // Reset binding
      bindSection(root);
    });
  });
})();
